
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@/utils/common";

@Component({})
export default class TestOrderPrint extends Vue {
  @Prop({ default: () => ({}) })
  data: any;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get $data() {
    this.data.warningDetails = this.data.warningDetails || [];
    return this.data;
  }
}
